import { render, staticRenderFns } from "./SpecialistsInitials.vue?vue&type=template&id=0bc4e7a2&scoped=true&"
import script from "./SpecialistsInitials.vue?vue&type=script&lang=js&"
export * from "./SpecialistsInitials.vue?vue&type=script&lang=js&"
import style0 from "./SpecialistsInitials.vue?vue&type=style&index=0&id=0bc4e7a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc4e7a2",
  null
  
)

component.options.__file = "SpecialistsInitials.vue"
export default component.exports